import { useRouter } from 'next/router';
import { FC } from 'react';
import SignupWizard from '../../components/Auth/SignupWizard';
import Seo from '../../components/Seo';
import { Button, H1 } from '../../components/ui';
import Container, { FlexContainer } from '../../components/ui/Container';
import LayoutFlexContainer from '../../components/ui/Container/LayoutFlexContainer';
import { LineRoundedChevron } from '../../components/ui/icons/exported/lineRoundedChevron';
import LineRoundedWrapper from '../../components/ui/icons/exported/lineRoundedWrapper';
import { Logo } from '../../components/ui/Logo';
import { useBreakpoints } from '../../utils';

const SignUpPage: FC = () => {
  const { isSmallScreen } = useBreakpoints();
  const router = useRouter();

  return (
    <LayoutFlexContainer padding={isSmallScreen ? 'xxs' : undefined}>
      <Seo title="Create account" />
      <FlexContainer padding="xxs" flexDirection="column" align="center">
        <Container padding={isSmallScreen ? 'xxs' : 'sm'} maxWidth="lg" bgColor="body">
          <FlexContainer align="center" justify="center" style={{ position: 'relative', marginBottom: '16px' }}>
            {isSmallScreen && (
              <Button ghost onClick={() => router.push('/login')} shadow={false}>
                <LineRoundedWrapper
                  style={{ rotate: '90deg', position: 'absolute', left: 0 }}
                  width="24px"
                  height="24px"
                >
                  <LineRoundedChevron stroke="black" />
                </LineRoundedWrapper>
              </Button>
            )}
            <FlexContainer flexDirection="column" align="center" gap="xs">
              <Logo width={180} />
              <H1>Join PYA</H1>
            </FlexContainer>
          </FlexContainer>
          <SignupWizard />
        </Container>
      </FlexContainer>
    </LayoutFlexContainer>
  );
};

export default SignUpPage;
